import React from 'react';
import Button from '../../../elements/Button/Button';

export default class Footer extends React.Component {
    render() {
        let {event, form, group, i18n, groupIndex, hasNext} = this.props;

        return <div className="content">
            <table className="layout">
                <tbody>
                    <tr>
                        <td className="text-left">
                            <Button style={event._local.styles.button_white} onClick={this.props.onGoPrev}>{i18n['navigation.back']}</Button>
                        </td>
                        {
                            hasNext
                                ? <td className="text-right">
                                        <Button style={event._local.styles.button} onClick={this.props.onGoNext}>{group.save_button_label}</Button>
                                    </td>
                                : null
                        }
                    </tr>
                </tbody>
            </table>
        </div>;
    }
}
